<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form :inline="true" size="mini">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-edit" @click="generateSMSDialog()">创建</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="default" icon="el-icon-download" @click="exportList()">导出</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form :inline="true" :model="formQuery" size="mini" class="smui-form-right">
                <el-form-item label="关键词">
                  <el-input v-model="formQuery.key" placeholder="ICCID/SIM卡号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchSMSList()">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          
          <div class="sanmuui-body-container">
              <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                @selection-change="handleSelectionChange"
                size="small"
                border
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="iccid"
                  label="ICCID号"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="sim"
                  label="SIM卡号"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="payload"
                  label="短信内容">
                </el-table-column>
                <el-table-column
                  prop="m_type"
                  label="短信类型"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="发送状态"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="create_time"
                  label="发送时间"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="account"
                  label="操作员"
                  width="100">
                </el-table-column>
              </el-table>
          </div>
          <div class="dv-pagging-container">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :page-size="pagging.pager_size"
              :pager-count="pagging.pager_count"
              :total="pagging.records_total"
              :current-page="pagging.current_page">
            </el-pagination>
          </div>
      </el-col>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="600px">
        <el-form :model="formNew" :rules="rules" ref="formNew" label-width="80px" class="demo-form-inline" size="medium">
          <el-form-item label="ICCID号" prop="iccids">
            <el-input type="textarea" 
              v-model="formNew.iccids" 
              :autosize="{ minRows: 10, maxRows: 30}"
              placeholder="输入ICCID卡号，支持多个，用逗号','或换行符隔开">
            </el-input>
          </el-form-item>
          <el-form-item label="内容" prop="payload">
            <el-input type="textarea" 
              v-model="formNew.payload" 
              :autosize="{ minRows: 10, maxRows: 20}"
              placeholder="请输入发送内容">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveSMS('formNew')" size="small">确 定</el-button>
        </div>
    </el-dialog>

  </el-container>
</template>

<script>
import Api from '../../api/index'

export default {
  name: 'sms_manage',
  data() {
    return {
      isVisible: false, // 控制浮动层是否显示
      dialogFormVisible: false,
      dialogTitle: "新增用户",
      formQuery: {
        key: '',
        page_index: 1,
        page_size: 20,
        sort_field: '',
        sort_type: ''
      },
      displayPassword: false,
      formLabelWidth: "110px",
      formNew: {
        iccids: "",
        payload: ""
      },
      rules: {
        iccids: [
          { required: true, message: '请输入ICCID号', trigger: 'blur' }
        ],
        payload: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },
      tableViewHeight: 600,
      multipleSelection: [],
      loadingTableData: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableData: [],
      pagging: {
        records_total: 0,
        pager_count: 5,
        pager_size: 20,
        current_page: 1
      },
      selectUserId: 0,
      selectUserName: '',
      fmpwd: {
        password: '',
        repassword: '',
      }
    }
  },
  methods: {
    openLayer() {
      this.isVisible = true;
    },
    closeLayer() {
      this.isVisible = false;
    },
    handleCurrentChange(val) {
      this.pagging.current_page = val;
      this.searchSMSList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 将字符串以逗号或换行符分割成数组
     * @param {string} str - 要分割的字符串
     * @returns {Array} 分割后的数组
     */
    splitByCommaOrNewline: function(str) {
      // 使用正则表达式匹配逗号或换行符（包括Windows和Unix风格的换行符）
      return str.split(/[,|\r\n|\n|\r]+/)
        // 过滤掉空字符串
        .filter(item => item.trim() !== '');
    },
    refreshPageList: function() {
      this.searchSMSList();
    },
    searchSMSList: function() {
      this.loadingTableData = true;
      this.tableData = [];

      this.formQuery.page_index = this.pagging.current_page;
      this.formQuery.page_size = this.pagging.pager_size;
      Api.SMSList(this.formQuery).then(res => {
        this.loadingTableData = false;
        if(res && res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          this.tableData = res.data;
        } else {
          // this.$message.error(err);
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    exportList: function() {
      var argdata = {
        Name: this.formInline.name,
        containChildren: true,
        HoldID: this.selectHoldId
      };
      Api.Hold_ExportList(argdata).then(res => {
          if(!res)
            return;
          if(res.code != 200) {
            this.$message.error(res.msg);
          }
          if(res.data) {
            var hostStr = window.location.host;
            var my_request = hostStr.indexOf('gps881.com') > -1 ?
                `https://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}` :
                `http://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}`;
            window.open(my_request);
          } else {
            this.$message.error('无数据导出！');
          }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    handleNodeClick: function(data) {
      this.selectHoldId = data.id;
      this.selectedHoldName = data.label;
      this.formInline.hold_id = this.selectHoldId;
      this.closeLayer();
      this.searchSMSList();
    },
    resetFormHoldInfo: function() {
      this.formNew = {
        iccids: "",
        payload: ""
      };
    },
    generateSMSDialog: function() {
      this.dialogFormVisible = true;
    },
    saveSMS: function(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const list = this.splitByCommaOrNewline(this.formNew.iccids);

          if(list.length === 0) {
            this.$message.error('请输入ICCID号');
            return;
          }

          this.formNew.iccids = list;
          Api.GenerateSMS(this.formNew).then(res => {
            if(res && res.code === 200) {
              this.$message({
                message: '恭喜你，提交成功！',
                type: 'success'
              });
              this.resetFormHoldInfo();
              this.dialogFormVisible = false;
              this.searchSMSList();
            } else {
              this.$message.error(`提交失败！${res ? res.msg : ''}`);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  mounted() {
    var h = document.body.clientHeight - 60 - 130;
    var h2 = document.body.clientHeight - 115;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.searchSMSList();
  }
}
</script>
<style>
.tree-divBox {
  padding-top: 10px;
  padding-left: 10px;
  width: 95%;
  min-height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.smui-form-right {
  float: right;
}
</style>